export const iconFontAwesomeFilesFilePowerpoint = (
	<i className="fa-solid fa-file-powerpoint"></i>
);
